import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import MeSkeleton from '../skeleton/index';
import Header from "../../../../../../components/header";
import { useIntl, FormattedMessage } from "react-intl";
import { useMemo } from "react";
import { ORDER_RETURN_CANCELED } from "../../../../utils/constant";
import { OrderPackageItem } from "../fragments/order-package";
import { useCallback } from "react";
import { unitPrice } from "../../../../../../../utils/product";
import OrderRecommend from "../fragments/order-recommend";
import OrderFixedFooter from "../fragments/order-fixed-footer";
import { OrderReturnStatusBtnLink } from "../../list/fragments/order-item/return";
import { action_fetch_order_return_detail } from "../../../../../../../store/actions/pages/customer";
import { useStore } from "react-redux";
import { useQuery } from "../../../../../../hooks/common";
import { useSelector } from "react-redux";


const ReturnProgress = props =>{
    const { returnRecords, orderStatus } = props;
    const Intl = useIntl();

    const returnRecordTitle = useMemo(() =>{
        if(orderStatus !== ORDER_RETURN_CANCELED){
            return Intl.formatMessage({ id: "return_record", defaultMessage: "Return Record" });
        }else{
            return Intl.formatMessage({ id: "return_canceled", defaultMessage: "Return Canceled" });
        }
    }, [orderStatus]);

    return <div className={cls.ReturnProgress}>
        <p className={cls.Title}>{returnRecordTitle}</p>

        {
            orderStatus !== ORDER_RETURN_CANCELED && <div className={cls.RecordList}>
                {
                    returnRecords?.map((record, index)=>(
                        <div 
                            className={`${cls.RecordSub} ${orderStatus===record?.status ? cls.Active: ''}`} 
                            key={record?.status+index}
                        >
                            <p className={cls.Font}>{record?.step}</p>
                            <p className={cls.Description}>{record?.description}</p>
                        </div>
                    ))
                }
            </div>
        }
        
    </div>
}

const OrderPackageProducts = props =>{
    const { returnOrderItems } = props;

    const disposeProduct = useCallback((product) =>{
        return {
            ...product,
            imageURL: product?.productImageUrl,
            name: product?.productName,
            price: product?.refundItemTotal
        }
    }, []);

    return <div className={cls.OrderPackageProducts}>
        <div className={cls.Hd}>
            <FormattedMessage id="item" defaultMessage="Item" />(s)
        </div>

        <div className={cls.PackageProducts}>
            {
                returnOrderItems?.map((product, index) =>(
                    <OrderPackageItem key={index+product?.productId} product={disposeProduct(product)} />
                ))
            }
        </div>
    </div>
}

const OrderReturnDetail = props =>{
    useStyles(cls);
    const params = useParams();
    const Intl = useIntl();
    const store = useStore();
    const query = useQuery();
    const pageCustomer = useSelector(state =>state.pageCustomer);
    const { orderReturnDetail } = pageCustomer;

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })

        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            await OrderReturnDetail.fetchData(store, params, query)
        }
    }, []);

    useEffect(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('EventEnter', {
                page: 'order',
                orderId: orderReturnDetail?.orderId
            })
        }
    }, [orderReturnDetail]);


    return <div className={cls.OrderReturnDetail}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "order_details", defaultMessage: "Order Details" })} 
        />

        {
            orderReturnDetail ? <React.Fragment>
                {
                    orderReturnDetail?.returnRecords?.length > 0 && <ReturnProgress orderStatus={orderReturnDetail.status} returnRecords={orderReturnDetail.returnRecords} />
                }
                
                <OrderPackageProducts returnOrderItems={orderReturnDetail?.returnOrderItems} />
            
                <div className={cls.TotalRefund}>
                    <div>
                        <FormattedMessage id="total_refund" defaultMessage="Total Refund" />
                    </div>

                    <div>
                        {unitPrice(orderReturnDetail?.refundTotal)}
                    </div>
                </div>

                <OrderRecommend orderId={orderReturnDetail?.orderId} />

                <OrderFixedFooter key={orderReturnDetail?.id}>
                    <OrderReturnStatusBtnLink orderItem={orderReturnDetail} isDetail />
                </OrderFixedFooter>
            </React.Fragment> : <React.Fragment>
                <MeSkeleton />
            </React.Fragment>
        }
    </div>
}

OrderReturnDetail.fetchData = async (store, params, search, headers) => {
    store.dispatch(action_fetch_order_return_detail(params.returnId, headers));
}

export default OrderReturnDetail;